import ImagePerson from "@/components/functionals/ImagePerson.vue";
import { formatDate } from "@/utils";
import formatterModulosRRHH from "@/components/functionals/formatterModulosRRHH.vue";
export default [
  {
    prop: "IdRequest",
    label: "ID",
    width: 125,
    sortable: true
    //formatter: HyperlinkForModuleVacations
  },
  {
    prop: "NameEmployee",
    label: "Empleado",
    sortable: true,
    formatter: ImagePerson,
    width: 200,
    attrs: {
      imgKey: "PhotoEmployee"
    }
  },
  {
    prop: "ApplicationDate",
    label: "Fecha Solicitud",
    width: 170,
    sortable: true,
    formatter: (props) => {
      // console.log(props)
      return formatDate(props.ApplicationDate, "DD/MM/YYYY");
    }
  },
  // {
  //   prop: "Cedula",
  //   label: "Cedula",
  //   width: 125,
  //   sortable: true
  //   //formatter: HyperlinkForModuleVacations
  // },
  // {
  //   prop: "Department",
  //   label: "Departamento",
  //   width: 125,
  //   sortable: true
  //   //formatter: HyperlinkForModuleVacations
  // },
  // {
  //   prop: "Position",
  //   label: "Posicion",
  //   width: 125,
  //   sortable: true
  //   //formatter: HyperlinkForModuleVacations
  // },
  {
    prop: "NoDays",
    label: "# Dias",
    width: 125,
    sortable: true
    //formatter: HyperlinkForModuleVacations
  },
  {
    prop: "StartDate",
    label: "Fecha Inicio",
    width: 125,
    sortable: true,
    formatter: (props) => {
      // console.log(props)
      return formatDate(props.StartDate, "DD/MM/YYYY");
    }
  },
  {
    prop: "FinishDate",
    label: "Fecha Fin",
    sortable: true,
    width: 125,
    formatter: (props) => {
      // console.log(props)
      return formatDate(props.FinishDate, "DD/MM/YYYY");
    }
  },
  // {
  //   prop: "Observations",
  //   label: "Observaciones",
  //   sortable: true,
  //   width: 125
  //   // formatter: HyperlinkForModuleVacations
  // },
  {
    prop: "SupervisorApproval",
    label: "Aprobacion Supervisor",
    sortable: true,
    width: 200,
    //value: true ?? false
    formatter: formatterModulosRRHH
  },
  {
    prop: "RRHH_Approval",
    label: "Aprobacion RRHH",
    sortable: true,
    width: 200,
    formatter: formatterModulosRRHH
    // formatter: HyperlinkForModuleVacations
  }
];
